import type {
  IsRouteEnabledOptions,
  RouteConfigMenu,
  RouteConfigSubMenu,
  LegacyRouteConfig,
  LegacyRouteConfigSubMenu,
} from "../../navigationConfig";
import { userPermissionHasAccess } from "../../utils";
export const getCheckRoutes =
  (isEnabledOption?: IsRouteEnabledOptions) =>
  (
    route:
      | LegacyRouteConfig
      | LegacyRouteConfigSubMenu
      | RouteConfigMenu
      | RouteConfigSubMenu["subRoutes"][0]
  ) =>
    userPermissionHasAccess(
      route.allowedPermissions,
      isEnabledOption?.userRights
    ) &&
    ("isEnabled" in route ? route.isEnabled({ ...isEnabledOption }) : true);
